import { useState } from "react";
import { METRICS } from "@/pages/admin/MatchResultDialog";
import { Markdown } from "@/components/Markdown";

const Report = ({ m }) => {
  const [full, setFull] = useState(false);
  if (!m.report) return null;
  const long = m.report.length > 400;
  return (
    <div data-testid={`video-report-${m.match_id}`} className="border-t border-slate-800 pt-3">
      <div className="eyebrow mb-1">{m.date} · vs {m.opponent}{m.label ? ` · ${m.label}` : ""}</div>
      <div className={long && !full ? "relative max-h-40 overflow-hidden" : ""}>
        <Markdown>{m.report}</Markdown>
        {long && !full && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-[#131927] to-transparent" />}
      </div>
      {long && (
        <button data-testid={`video-report-toggle-${m.match_id}`} onClick={() => setFull(!full)} className="mt-1 font-data text-[11px] uppercase tracking-wider text-[#FF2D78]">
          {full ? "Show less" : "Read full report"}
        </button>
      )}
    </div>
  );
};

export const VideoMatches = ({ matches }) => {
  const rows = [...matches].sort((a, b) => (b.date || "").localeCompare(a.date || ""));
  const total = (k) => rows.reduce((s, m) => s + (Number(m.metrics?.[k]) || 0), 0);
  return (
    <div className="space-y-4">
      <div className="overflow-x-auto">
        <table data-testid="video-matches-table" className="w-full min-w-[520px] text-sm">
          <thead><tr className="text-left font-data text-[10px] uppercase tracking-wider text-slate-500">
            <th className="py-2 pr-3">Date</th><th className="py-2 pr-3">Match</th>
            {METRICS.map(([k, l]) => <th key={k} className="py-2 pr-3 text-right">{l}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.match_id} data-testid={`video-match-row-${m.match_id}`} className="border-t border-slate-800">
                <td className="py-2 pr-3 font-data text-slate-400">{m.date}</td>
                <td className="py-2 pr-3 text-white">vs {m.opponent}{m.label ? <span className="block text-[11px] text-slate-500">{m.label}</span> : null}</td>
                {METRICS.map(([k]) => <td key={k} className="py-2 pr-3 text-right font-data text-white">{m.metrics?.[k] ?? "—"}</td>)}
              </tr>
            ))}
            {rows.length > 1 && (
              <tr data-testid="video-matches-total" className="border-t border-slate-600 font-semibold">
                <td className="py-2 pr-3 font-data text-slate-400" colSpan={2}>Season total · {rows.length} matches</td>
                {METRICS.map(([k]) => <td key={k} className="py-2 pr-3 text-right font-data text-white">{total(k)}</td>)}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {rows.map((m) => <Report key={m.match_id} m={m} />)}
    </div>
  );
};
